import {createSelector, Selector} from 'reselect';
import _ from 'lodash';

export function createSelectorIdObj<T extends (number | string), S = any>(sel: Selector<S, T[]>) {
	return createSelector(
		sel,
		(ids) => _.transform<T, Record<T, boolean>>(ids, (result, id) => {
			result[id] = true;
			return result;
		}, {} as Record<T, boolean>))
}